import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import PaginatedReportIcon from '../../assets/images/PaginatedReportIcon.svg?react'

export default function ReportPlaceholder() {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: 0.6,
      }}
    >
      <PaginatedReportIcon height={60} width={60} style={{ marginBottom: 5 }} />
      <Typography align={'center'} variant="h5" sx={{ marginBottom: '10px' }}>
        {t('reports.noReportSelected')}
      </Typography>
      <Typography align={'center'}>{t('reports.pleaseSelectAReport')}</Typography>
    </Box>
  )
}
